import { Mime } from '@shared/api/common/mime-type';

export abstract class FileUtil {
  static readFile(blob: Blob, method: "arrayBuffer"): Promise<ArrayBuffer>;
  static readFile(blob: Blob, method: "text"): Promise<string>;
  static readFile(blob: Blob, method: "dataUrl"): Promise<string>;
  static readFile(blob: Blob, method: "dataUrl" | "arrayBuffer" | "text") {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.onerror = (event) => {
        reject(event.target.error);
      };

      switch (method) {
        case "arrayBuffer":
          reader.readAsArrayBuffer(blob);
          break;
        case "dataUrl":
          reader.readAsDataURL(blob);
          break;
        case "text":
          reader.readAsText(blob);
          break;
      }
    });
  }

  /**
   * Convert a data URI to a blob.
   *
   * @param dataUri The data URI to convert to a blob
   * @returns A blob representing that data URI
   */
  static dataUriToBlob(dataUri: string): Blob {
    const binary = atob(dataUri.split(',')[1]);
    const type = this.getDataUriMimeType(dataUri);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type });
  }

  /**
   * Get the MIME Type embedded in a data URI.
   *
   * @param dataUri The data URI to get the mime type from
   * @returns The data URI's mime type
   */
  static getDataUriMimeType(dataUri: string): Mime {
    const mimeType = dataUri.split(',')[0].split(':')[1].split(';')[0];
    return mimeType as Mime; // it's either a mime type we know about or it's completely unknown
  }
}
